function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cf5285;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.216,4.562a5.335,5.335,0,0,1,1.467,4.782,3.168,3.168,0,0,1,1.381,5.293l-4.842,4.807-2.686-2.667L9.889,19.431,2.351,11.883A5.334,5.334,0,0,1,9.89,4.359,5.332,5.332,0,0,1,17.216,4.562Zm-5.583,6.852a1.378,1.378,0,0,0,0,1.963l3.589,3.564,3.589-3.564a1.378,1.378,0,0,0,0-1.963,1.434,1.434,0,0,0-2.016,0L15.22,12.974,13.97,11.733l-.323-.32a1.434,1.434,0,0,0-2.014,0ZM3.82,5.82a3.555,3.555,0,0,0-.171,4.845l6.24,6.25,1.386-1.388-.894-.889a3.156,3.156,0,0,1,0-4.486,3.213,3.213,0,0,1,4.519,0l.323.32.323-.32a3.2,3.2,0,0,1,1.3-.784,3.555,3.555,0,0,0-5.77-3.685L9.891,6.747,8.7,5.683A3.555,3.555,0,0,0,3.82,5.82Z",
  transform: "translate(-1 -3)"
});

function SvgParent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16.444,
    viewBox: "0 0 20 16.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParent);
export default __webpack_public_path__ + "static/media/parent.211757f822b75af44b7ca8814e370556.svg";
export { ForwardRef as ReactComponent };